"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TypeIconStyle = _styledComponents.default.div`
  align-items: center;
  background-color: ${({
  theme,
  variant
}) => theme.colors[variant]};
  display: flex;
  justify-content: center;
  line-height: 100%;
  min-width: 30px;
  text-align: center;
  span {
    &:before {
      color: ${({
  theme
}) => theme.colors.white};
    }
  }

  ${({
  theme,
  transparent,
  variant
}) => transparent && (0, _styledComponents.css)`
      background-color: transparent;
      span {
        &:before {
          color: ${theme.colors[variant]};
        }
      }
    `}
`;
TypeIconStyle.defaultProps = {
  variant: "info",
  theme: _base.default,
  transparent: false
};
TypeIconStyle.propTypes = {
  variant: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),
  border: _propTypes.default.bool,
  transparent: _propTypes.default.bool
};
var _default = TypeIconStyle;
exports.default = _default;